module.exports = __webpack_public_path__ + "img/Intro.296d5a07.png";